<template>
  <div class="reports-filter-root" :class="{'isRelative': isRelative}">
    <div class="title">
      <span>Filteri</span>
      <img v-if="showCloseIcon" @click="onClose" class="close-icon" src="../../assets/icons/close.png" />
    </div>
    <div class="filter-content">
      <div class="filter-item">
        <v-menu
          ref="dateMenu"
          :close-on-content-click="true"
          v-model="dateMenu"
          :return-value.sync="filter.selectedDate"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="filter.selectedDate"
            label="Odaberite datum"
            readonly
          ></v-text-field>

          <v-date-picker
            v-model="filter.selectedDate"
            @input="$refs.dateMenu.save(filter.selectedDate)"
            no-title
            scrollable
          ></v-date-picker>
        </v-menu>
      </div>
      <div v-if="filter.dateToIncluded" class="filter-item">
        <v-menu
          ref="dateToMenu"
          :close-on-content-click="true"
          v-model="dateToMenu"
          :return-value.sync="filter.selectedDateTo"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="filter.selectedDateTo"
            label="Odaberite datum do"
            readonly
          ></v-text-field>

          <v-date-picker
            v-model="filter.selectedDateTo"
            @input="$refs.dateToMenu.save(filter.selectedDateTo)"
            no-title
            scrollable
          ></v-date-picker>
        </v-menu>
      </div>
      <div class="filter-item">
        <v-select
          v-model="filter.selectedStudio"
          :items="studioList"
          item-text="Name"
          item-value="StudioId"
          label="Odaberite studio"
        ></v-select>
      </div>
      <div class="filter-item">
        <v-container pa-0>
          <v-layout row wrap>
            <v-flex xs12 sm6 m-0 p-0>
              <p>Vrijeme</p>
              <vue-timepicker
                class="time-picker"
                v-model="filter.time"
                :minute-interval="5"
              ></vue-timepicker>
            </v-flex>
            <v-flex xs12 sm6 v-if="filter.timeToIncluded">
              <p>Vrijeme do</p>
              <vue-timepicker
                class="time-picker"
                v-model="filter.timeTo"
                :minute-interval="5"
              ></vue-timepicker>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
      <div class="filter-checkboxes">
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-checkbox
              :label="'Datum do'"
              v-model="filter.dateToIncluded"
            ></v-checkbox>
          </v-flex>
          <v-flex xs12 sm6>
            <v-checkbox
              :label="'Vrijeme do'"
              v-model="filter.timeToIncluded"
            ></v-checkbox>
          </v-flex>
        </v-layout>
      </div>
    </div>
    <div class="filter-actions">
      <v-layout row justify-end>
        <v-btn color="primary" @click="() => applyFilters(false)">Filtriraj</v-btn>
        <v-btn @click="clearFilters">Ocisti filtere</v-btn>
      </v-layout>
    </div>
  </div>
</template>

<script>
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
export default {
  props: ['isRelative', 'showCloseIcon'],
  components: {
    VueTimepicker,
  },
  data() {
    return {
      studioList: [],
      dateMenu: false,
      dateToMenu: false,
      filter: {
        selectedDate: null,
        selectedDateTo: null,
        dateToIncluded: false,
        time: null,
        timeTo: null,
        timeToIncluded: false,
        selectedStudio: null,
      },
    };
  },
  created() {
    this.getStudioList();
    this.applyFilters();
  },
  methods: {
    getStudioList() {
      this.$store.state.services.studioService
        .getForDropdown()
        .then((response) => {
          this.studioList = response.data;
        });
    },
    applyFilters(initialEmit) {
      this.$emit('onFilterChanged', {
        StudioId: this.filter.selectedStudio,
        DateFrom: this.filter.selectedDate,
        DateTo: this.filter.selectedDateTo,
        TimeFrom: this.filter.time,
        TimeTo: this.filter.timeTo,
        initialEmit: initialEmit
      })
    },
    clearFilters() {
      this.filter = {
        selectedDate: null,
        selectedDateTo: null,
        dateToIncluded: false,
        time: null,
        timeTo: null,
        timeToIncluded: false,
        selectedStudio: null,
      };
      this.$emit('onFilterChanged', {
        StudioId: null,
        DateFrom: null,
        DateTo: null,
        TimeFrom: null,
        TimeTo: null,
        initialEmit: false
      })
    },
    onClose() {
      this.$emit('onCloseClicked')
    }
  },
};
</script>

<style scoped>
.reports-filter-root {
  /* height: 47vh; */
  position: absolute;
  top: 100px;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0px 20px 10px rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  z-index: 7;
}
.reports-filter-root.isRelative {
  position: relative;
  top: 0;
}
.reports-filter-root .title {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  background: #fff;
  padding: 20px;
  z-index: 1;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.filter-content {
  height: 100%;
  padding: 70px 20px;
  overflow-y: auto;
}
.reports-filter-root .filter-actions {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  background: #fff;
  padding: 10px;
  z-index: 1;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

@media(max-width: 1100px) {
  
}
</style>
